<template>
    <div class="infor-content">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('cookiePolicy.title')}}
                <hr>
            </span>
        </h1>
        <div class="row">
            <p style="width:100%;text-align:left">{{$t('cookiePolicy.textItem')}}</p>
        </div>
        <!-- CookiePolicy -->
        <div class="row info-row">
            <h1>{{$t('cookiePolicy.which.title')}}</h1>
            <p v-for="item in $t('cookiePolicy.which.textItem')" v-html="item"></p>
            <h1>{{$t('cookiePolicy.what.title')}}</h1>
            <p v-for="item in $t('cookiePolicy.what.textItem')" v-html="item"></p>
            <h1>{{$t('cookiePolicy.why.title')}}</h1>
            <p v-for="item in $t('cookiePolicy.why.textItem')" v-html="item"></p>
            <h1>{{$t('cookiePolicy.whatTypes.title')}}</h1>
            <p v-for="item in $t('cookiePolicy.whatTypes.textItem')" v-html="item"></p>
            <h1>{{$t('cookiePolicy.howCan.title')}}</h1>
            <p v-for="item in $t('cookiePolicy.howCan.textItem')" v-html="item"></p>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
    .info-row h1{
        font-size: 3rem;
        font-weight: bold;
        color:#29AAE1;
        text-align: left;
        margin-bottom: 4rem;
    }
    .info-row p{
        width:100% !important;
        text-align:left;
        margin:2rem 0;
    }
    @media (max-width: 767px){
        .info-row h1{
            font-size: 1rem;
            margin-bottom: 4rem;
            margin-left: 1rem;
            margin-bottom: 2rem;
        }
        .info-row p{
            margin:1rem 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Footer/CookiePolicy.vue